import { apiRequest } from "../../index";

export const addHotel = async (hotelData) => {
  return apiRequest("/api/owner/hotel-management", "POST", hotelData , true);
};

export const getAllHotels = async ({page , limit}) => {
  return apiRequest(`/api/owner/hotel-management?page=${page}&limit=${limit}`, "GET");
};

export const getHotelById = async (hotelId) => {
  return apiRequest(`/api/owner/hotel-management/${hotelId}`, "GET");
};

export const updateHotel = async (hotelId, hotelData) => {
  return apiRequest(`/api/owner/hotel-management/${hotelId}`, "PUT", hotelData , true);
};

export const deleteHotel = async (hotelId) => {
  return apiRequest(`/api/owner/hotel-management/${hotelId}`, "DELETE");
};

export const getAllHotelsForMenu = async ({page , limit}) => {
  return apiRequest(`/api/owner/hotel-management?page=${page}&limit=${limit}&hasRestaurant=true`, "GET");
};